/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SprachbedarfInputs */

const de__field_sprachbedarf = /** @type {(inputs: _Field_SprachbedarfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hier Sprache angeben`)
};

/**

* @param {_Field_SprachbedarfInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_sprachbedarf = /** @type {((inputs?: _Field_SprachbedarfInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SprachbedarfInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_sprachbedarf(inputs)
});